import { render, staticRenderFns } from "./CommentScreenRecorder.vue?vue&type=template&id=6e92002d&scoped=true"
import script from "./CommentScreenRecorder.vue?vue&type=script&lang=ts"
export * from "./CommentScreenRecorder.vue?vue&type=script&lang=ts"
import style0 from "./CommentScreenRecorder.vue?vue&type=style&index=0&id=6e92002d&prod&lang=scss"
import style1 from "./CommentScreenRecorder.vue?vue&type=style&index=1&id=6e92002d&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e92002d",
  null
  
)

export default component.exports